import { Link, useLocation } from "react-router-dom";

function Footer() {
  const currentYear = new Date().getFullYear();

  const currentUrl = useLocation();

  return (
    <footer className="w-full h-fit px-8">
      <div className="flex  flex-wrap justify-around items-start gap-6">
        <div className="w-[40vw] lg:w-[20vw] pt-12 flex flex-col justify-center items-center">
          <div className="w-20 lg:w-32">
            <img
              src="https://res.cloudinary.com/dcpgwly0i/image/upload/v1750517663/logo-sqaure-attnq_cwnyfe.png"
              alt="attnq-logo-footer"
            />
          </div>
          <div className="text-gray-700 text-sm leading-[1.62rem] mt-[-1rem] text-center">
            <p>
              Business:{" "}
              <span className="underline-offset-3 underline">
                <a href="mailto:info@attnq.com">info@attnq.com</a>
              </span>
            </p>
            <p>
              HR:{" "}
              <span className="underline underline-offset-3">
                <a href="mailto:hr@attnq.com">hr@attnq.com</a>
              </span>
            </p>
          </div>
        </div>

        <div className="w-[40vw] lg:w-[20vw] pt-16 text-center">
          <h2 className="font-semibold">COMPANY</h2>
          <ul className="text-gray-700 text-sm">
            <li className="pt-3">
              <Link to="about-us">About Us</Link>
            </li>
            <li className="py-3">
              <Link to="careers">Careers</Link>
            </li>
            <a href="" className="py-3">
              LinkedIn
            </a>
          </ul>
        </div>

        <div className="w-[40vw] lg:w-[20vw] pt-16 text-center">
          <h2 className="font-semibold">QUICK LINKS</h2>
          <ul className="text-gray-700 text-sm">
            <li className="pt-3">
              <Link to="agent-domain">For Brokers</Link>
            </li>
            <li className="py-3">
              <Link to="buyer-query">For Investors</Link>
            </li>
            <li>
              {currentUrl.pathname === "/" ? (
                <a href="#features">Features</a>
              ) : null}
            </li>
          </ul>
        </div>

        <div className="w-[40vw] lg:w-[20vw] pt-16 text-center">
          <h2 className="font-semibold">POLICIES</h2>
          <ul className="text-gray-700 text-sm">
            <li className="pt-3">
              <Link to="privacy-policy">Privacy Policy</Link>
            </li>
            <li className="py-3">
              <Link to="terms-conditions">Terms And Conditions</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-10 flex justify-center items-center">
        <p className="inline-block text-gray-700 text-sm border-t border-gray-400 py-1 px-6">
          Copyright &copy; {currentYear} AttnQ. All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
